import React from 'react';

interface IAppContext {
	app: any;
	onAppChange: any;
	showAlert: any;
	campaignOptions: Array<{ id: string; label: string }>;
	setCampaignOptions: (campaignOptions: Array<{ id: string; label: string }>) => void;
}

const AppContext = React.createContext<IAppContext>({} as IAppContext);

export default AppContext;
